import React from 'react';

const LogoBorder = ({ logoUrl, logoSize = 50, gap = 5 }) => {
  // Generar filas y columnas
  const createRow = (count) =>
    Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="logo"
        style={{
          backgroundImage: `url(${logoUrl})`,
          width: `${logoSize}px`,
          height: `15px`,
        }}
      ></div>
    ));

    const createColumn = (count, rotate) =>
      Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="logo"
        style={{
          backgroundImage: `url(${logoUrl})`,
          width: `${logoSize}px`,
          height: `15px`,
          transform: `rotate(${rotate}deg)`, 
        }}
      ></div>
    ));

  // Cantidad de logos
  const logosPerRow = Math.ceil(window.innerWidth / (logoSize + gap));
  const logosPerColumn = Math.ceil(window.innerHeight / (logoSize + gap));

  return (
    <div className="logo-border">
      {/* Fila superior */}
      <div className="top-row">{createRow(logosPerRow)}</div>

      {/* Fila inferior */}
      <div className="bottom-row">{createRow(logosPerRow)}</div>

      {/* Columna izquierda */}
      <div className="left-column">{createColumn(logosPerColumn, -90)}</div>

      {/* Columna derecha */}
      <div className="right-column">{createColumn(logosPerColumn, 90)}</div>
    </div>
  );
};

export default LogoBorder;
